<template>
  <v-select
    v-model="area"
    :error-messages="errors"
    outlined
    :loading="loading"
    :disabled="loading"
    label="Salão"
    :items="areas"
    item-text="description"
    item-value="id"
  ></v-select>
</template>

<script>
import {
  mapGetters,
  mapActions,
} from 'vuex'
import axios from '@/plugins/axios'

export default {

  components: {},
  props: {
    value: {},
    errors: {},
  },

  data: () => ({
    loading: false,
    area: '',
    areas: [],
  }),

  watch: {
    value(val) {
      this.area = val
    },
    area() {
      this.$emit('input', this.area)
      this.$emit('change')
    },

  },

  created() {
    this.loadCommonArea()
    this.areas = this.getCommonArea
    this.area = this.value
  },
  computed: {
    ...mapGetters('select', ['getCommonArea']),
  },
  methods: {
    ...mapActions('select', ['loadCommonArea']),
  },
}
</script>
